export default {"src":"/_next/static/media/darkWarning.934cdd28.svg","height":18,"width":19,"blurWidth":0,"blurHeight":0};